import Firebase from 'firebase'
// Required for side-effects
// require("firebase/functions");
export const app = Firebase.initializeApp(process.env.FIREBASE_CONFIG);
export const db = app.database()
export const storage = app.storage()
export const functions = app.functions()
export const auth = app.auth()
export const firebase = Firebase

export default function firebaseInit() {
  app.auth();
}



// WEBPACK FOOTER //
// ./src/shared/firebase/firebase-init.js